import type { ProfileResponse } from '../../api/account';

export function profileCounts(profile: ProfileResponse | null) {
  const value = (capability: keyof ProfileResponse['capabilities'], amount: number | null | undefined) =>
    profile?.capabilities[capability] && amount != null && Number.isFinite(amount) && amount >= 0 ? amount : null;
  return {
    voices: value('voices_count', profile?.counts.voices),
    avatars: value('variants_count', profile?.counts.variants),
    people: value('people_count', profile?.counts.people),
    fav: value('fav_count', profile?.counts.fav),
    made: value('made', profile?.stats.made),
    spent: value('spent', profile?.stats.spent),
    streak: value('streak', profile?.stats.streak),
  };
}
